import { Lightning as lng, Registry, Router } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { Button } from '../../components/shared/Button';
import { ScreenSize } from '../../api/ScreenSize';
import { PlayerController } from '../../Business/player/PlayerController';
import { Backend } from '../../api/Backend';
import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { PLAYER_STOP_REASON } from '../../Business/player/logicHandlers/AnalyticsHandler';
import { MainCategories, POPUP_TYPE, PropertyKeys, TrackSubcategories } from '../../api/analytics/ClientEvents';
import { addProperty } from '../../api/analytics/AnalyticsUtil';
import { IProperty } from '../../api/models/AndromeTV.types';

export class ContinueWatchingDialog extends lng.Component {
  private inactiveTimeout: number | undefined;
  private playerController: PlayerController | undefined;
  private backend: Backend | undefined;
  static override _template() {
    return {
      x: 0,
      y: 0,
      w: (w: number) => w,
      h: (h: number) => h,
      rect: true,
      color: Theme.Colors.MessageDialog.Background,

      Dialog: {
        x: (w: number) => w / 2,
        y: (h: number) => h / 2,
        mountX: 0.5,
        mountY: 1,
        flex: { direction: 'column' },
        Title: {
          w: ScreenSize.w / 3,
          visible: this.bindProp('title', ctx => !!ctx.title),
          text: {
            text: this.bindProp('title'),
            ...Theme.Fonts.MessageDialog.Title,
          },
        },
        Message: {
          w: ScreenSize.w / 3,
          text: {
            text: this.bindProp('message'),
            ...Theme.Fonts.MessageDialog.Message,
          },
        },
        Button: {
          y: 16,
          type: Button,
          buttonMode: 'dialog',
          h: 80,
          label: this.bindProp('confirmText'),
          signals: {
            onActivate: '_activate',
          },
        },
      },
    };
  }

  override _active() {
    const properties: IProperty[] = [];
    addProperty(PropertyKeys.type, POPUP_TYPE.CONTINUE_WATCHING, [], properties);
    this.backend?.logService.createClientEventEntry(
      { type: MainCategories.TRACK, subType: TrackSubcategories.POPUP },
      properties
    );
    const timeoutTime =
      this.backend?.globalSettings.numberValue(GlobalSettingsKeys.continueWatchingPopupDuration) || 300000;
    this.inactiveTimeout = Registry.setTimeout(() => {
      this.playerController?.endStream(false, false, true, PLAYER_STOP_REASON.NO_INTERACTION);
      this.fireAncestors('$forceCloseMessage');
      Router.navigate('main');
    }, timeoutTime);
  }

  _activate() {
    // close popup
    // restart stream
    Registry.clearTimeout(this.inactiveTimeout);
    this.playerController?.restartStream();
    this.fireAncestors('$forceCloseMessage');
  }

  override _getFocused() {
    return this.tag('Button');
  }

  override _handleBack() {
    //do not allow closing the dialog via back
    return true;
  }
}
